import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { 
  Button,
  FormGroup, 
  FormControl, 
  InputGroup,
  Modal } from 'react-bootstrap';

class UpdateSetModal extends Component {
  constructor(props) {
    super(props);
    this.handleOkClick = this.handleOkClick.bind(this);
  }

  handleOkClick(key) {

    const exercise = ReactDOM.findDOMNode(this.exerciseFormControl);
    const weight = ReactDOM.findDOMNode(this.weightFormControl);
    const reps = ReactDOM.findDOMNode(this.repsFormControl);
    const timeStamp = ReactDOM.findDOMNode(this.timeFormControl);

    const newSet = {
      key: key,
      exerciseKey: exercise.value,
      weight: Number.parseFloat(weight.value),
      reps: Number.parseFloat(reps.value),
      timeStamp: new Date(Number.parseInt(timeStamp.value, 10)).getTime()
    }

    this.props.onOk(newSet);
  }

  renderExerciseOption(exercise) {
    return(
      <option key={exercise.key} value={exercise.key}>{exercise.name}</option>
    );
  }

  render() {
    const { set, exercises } = this.props;
    const exerciseOptions = Object.keys(exercises).map(key => this.renderExerciseOption(exercises[key]));

    return(
        <Modal show={this.props.show}>
          <Modal.Header closeButton>
            Edit Exercise
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <FormControl 
                componentClass="select" 
                defaultValue={set.exerciseKey}
                ref={(control) => this.exerciseFormControl = control }
              >
                {exerciseOptions}
              </FormControl>
              <InputGroup>
                <FormControl
                  type="number"
                  placeholder="Weight lifted"
                  defaultValue={set.weight}
                  ref={(control) => this.weightFormControl = control }
                  required
                />
                <InputGroup.Addon>lbs</InputGroup.Addon>
              </InputGroup>
              <InputGroup>
                <FormControl
                  type="number"
                  placeholder="Number of reps"
                  defaultValue={set.reps}
                  ref={(control) => this.repsFormControl = control }
                  required
                />
                <InputGroup.Addon>reps</InputGroup.Addon>
              </InputGroup>
              <FormControl
                type="text"
                placeholder="Time"
                defaultValue={set.timeStamp}
                ref={(control) => this.timeFormControl = control }
                required
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={(event) => this.handleOkClick(set.key)}>OK</Button>
            <Button onClick={this.props.onCancel}>Cancel</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

UpdateSetModal.propTypes = {
  show: React.PropTypes.bool.isRequired,
  set: React.PropTypes.object.isRequired,
  onOk: React.PropTypes.func.isRequired,
  onCancel: React.PropTypes.func.isRequired,
  exercises: React.PropTypes.object.isRequired
}

export default UpdateSetModal;


// WEBPACK FOOTER //
// ./src/components/UpdateSetModal.jsx